import { useNavigate } from 'react-router-dom'

import Header from '@/components/Header'
import Hero from '@/components/Hero'

const HomePage = () => {
  const navigate = useNavigate()
  const { isLoggedIn, userInfo } = useUserStore()

  const onLoginClick = () => {
    navigate('/login')
  }

  const onPricingClick = () => {
    navigate('/pricing')
  }

  return (
    <>
      <Header userInfo={userInfo} isLoggedIn={isLoggedIn} onPricingClick={onPricingClick} onLoginClick={onLoginClick} />
      <Hero />
    </>
  )
}

export default HomePage
